<template>
  <div class="join-us-page">
      <fancy-header></fancy-header>
      <div class="container">
          <div class="row">
              <div class="section-header">
              <div class="col-xs-12 text-center">
                  <h2>انضم لنا</h2>
              </div>     
              </div>
             
          </div>
          <div class="row">
              <div class="col-xs-12" v-if="!sent">
                  <form @submit.prevent="applyNow()">
                      <div class="col-xs-12">
                          <h3>معلومات الاتصال</h3>
                      </div>
                      <div class="col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="firstname">الاسم</label>
                            <input type="text" class="form-control" id="firstname" v-model="applicant.FirstName" required>
                            </div>
                      </div>
                      <div class="col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="lasttname"> الكنية</label>
                            <input type="text" class="form-control" id="lasttname" v-model="applicant.LastName" required>
                            </div>
                      </div>
                      <div class="col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="email">عنوان بريدك الالكتروني</label>
                            <input type="email" class="form-control" id="email" v-model="applicant.Email" required>
                        </div>
                      </div>
                       <div class="col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="phone">رقم الجوال</label>
                            <input type="text" class="form-control" id="phone" v-model="applicant.Phone" required>
                            </div>
                      </div>
                       <div class="col-xs-12">
                          <h3>الدراسات</h3>
                      </div>
                      <div class="col-xs-12">
                            <div class="form-group">
                                <input type="text" class="form-control" id="educations" v-model="applicant.Studies">    
                            </div>
                      </div>
                       <div class="col-xs-12">
                          <h3>المهارات و الخبرات</h3>
                      </div>
                       <div class="col-xs-12">
                            <div class="form-group">
                                <input type="text" class="form-control" id="experiences" v-model="applicant.Experiences">    
                            </div>
                      </div>
                       <div class="col-xs-12">
                          <h3> ملف السيرة الذاتية</h3>
                      </div>
                       <div class="col-xs-12">
                            <div class="form-group">
                                <input type="file" class="form-control inputfile" ref="cvFileInput" required>    
                                <label>
                                    <span class="fas fa-upload"></span>
                                    <span>اختار ملف</span>
                                </label>
                            </div>
                      </div>
                        <div class="col-xs-12">
                          <h3>اخبرنا عن نفسك</h3>
                      </div>
                       <div class="col-xs-12">
                            <div class="form-group">
                                <textarea  class="form-control" rows="10" v-model="applicant.Biography"> </textarea>
                            </div>
                      </div>
                      <div class="col-xs-12" v-if="error">
                          <h6 class="error">حصل خطأ أثناء إرسال طلبك. يرجى المحاولة مجدداً.</h6>
                      </div>
                      <div class="col-xs-12">
                            <div class="form-group">
                                <button type="submit" class="form-control">ارسال</button>
                            </div>
                      </div>
                  </form>
              </div>
              <div class="col-xs-12" v-if="sent">
                  <p class="thanks">تمّ استلام طلبك. سنقوم بالتواصل معك في أقرب وقت ممكن. شكراً على اهتمامك!</p>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import FancyHeader from '@/components/shared/fancy-header'
import  'bootstrap-tagsinput/dist/bootstrap-tagsinput.min.js';
export default {
    name:'JoinUs',

    data: () => ({
        applicant: {
            FirstName: "",
            LastName: "",
            Email: "",
            Phone: "",
            Studies: "",
            Experiences: "",
            Biography: "",
        },
        sent: false,
        error: false,
    }),

    methods: {
        applyNow() {
            const formData = new FormData();
            formData.append("FirstName", this.applicant.FirstName);
            formData.append("LastName", this.applicant.LastName);
            formData.append("Email", this.applicant.Email);
            formData.append("Phone", this.applicant.Phone);
            formData.append("Studies", this.applicant.Studies);
            formData.append("Experiences", this.applicant.Experiences);
            formData.append("Biography", this.applicant.Biography);
            formData.append("cv", this.$refs.cvFileInput.files[0]);

            NProgress.start();
            axios.post(apiHost + "/apply", formData).then(response => {
                this.sent = true;
                this.scrollToTop();
			}).catch(error => {
				this.error = true;
			}).finally(() => NProgress.done());
        }
    },

    components: {
        FancyHeader
    },
}
</script>

<style lang="scss">
    @import "src/assets/sass/shared.scss";
    @import "node_modules/bootstrap-tagsinput/dist/bootstrap-tagsinput";

.join-us-page{

       .section-header{
        h2{
            color:$secondary-color;
            width:35%;
            margin:20px auto 0px;
            &::after{
                content: '';
                display: block;
                position: relative;
                background-image: url("/src/assets/img/separator.png");
                background-repeat: no-repeat;
                background-size: cover;
                margin-top: 30px;
                width: 100%;
                padding-bottom:8%;
            }
        }
    }
    form{
        margin-bottom:30px;
        overflow: auto;
        & > div{
            @include float-left($dir);
        }
        .form-group{
            position: relative;
            direction:$dir;
        }
        label{
            color:#555;
            font-weight: 500;
            @include text-align($dir);
        }
        h3{
            @include text-align($dir);
            
        }
        .form-control{
            height:40px;
            &:focus{
                border-color:$main-color;
                box-shadow:0px 0px 4px 0px  $main-color;
            }
        }
        .inputfile {
            position: relative;
            z-index: 1;
            opacity: 0;
            
            & +  label{
              cursor: pointer;
               position: absolute;
                top:0px;
                left:0px;
                width:100%;
                height:100%;
                z-index: 0;
                background-color:#fff;
                color:$main-color;
                border:1px solid $main-color;
                display: flex;
                align-items: center;
                text-align: left;
                span{
                    margin:0px 5px;
                } 
          }
        }
        textarea.form-control{
            height: auto;
        }

        .btn-add, button.form-control {
            background-color:#fff;
            border:1px solid $main-color;
            color:$main-color;
            margin-top:27px;
            @include prefixer(transition,all 0.4s ease-in-out,("moz","webkit","ms","o")); 
            &:hover{
            background-color:$main-color;
            color:#fff;    
            }
        }
        .bootstrap-tagsinput{
            width:100%;
        }
        .label-info{
            background-color:$main-color;   
        }
    }
    .thanks {
        text-align: center;
        direction: rtl;
        font-size: 19px;
        margin-top: 40px;
        margin-bottom: 60px;
    }
    .error {
        text-align: right;
        direction: rtl;
        color: red;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/join-us.vue